<plugins-button
  [text]="true"
  [ariaLabel]="label ?? ('clearInput.label' | translate)"
  (clicked)="clear.emit()"
>
  <icon-cancel [size]="16" />
</plugins-button>
